import React, { createContext, useReducer } from "react";
import ProformaReportReducer from "../../reducers/reports/proformaReportReducer";
import axios from "../../../axios";

const initialState = {
  loading: false,
  proformas: [],
  totalAmount: 0,
  totalVat: 0,
  count: 0,
  error: null,
  clients: [],
};

export const ProformaReportContext = createContext(initialState);

export const ProformaReportProvider = ({ children }) => {
  const [state, dispatch] = useReducer(ProformaReportReducer, initialState);

  // ✅ Get Proforma Report
  const getProformaReportHandler = async (filter) => {
    // dispatch({ type: 'PROCESS_START' });
    try {
      const result = await axios.get(
        `/api/v1/bookings/proformareport?${filter}`,
      );

      dispatch({
        type: "FETCH_PROFORMA_RECORDS",
        payload: result.data,
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: "PROCESS_ERROR",
        payload: error,
      });
    }
  };
  // ✅ Get Clients for Dropdown
  const getClientsHandler = async (company) => {
    try {
      const result = await axios.get(`/api/v1/clients?companyName=${company}`);
      dispatch({ type: "FETCH_CLIENT_RECORD", payload: result.data });
    } catch (error) {
      console.error(error);
    }
  };

  // ✅ Clear State
  const clearProformaStateHandler = () => {
    dispatch({ type: "PROCESS_START" });
  };

  return (
    <ProformaReportContext.Provider
      value={{
        loading: state.loading,
        proformas: state.proformas,
        clients: state.clients,
        totalAmount: state.totalAmount,
        totalVat: state.totalVat,
        count: state.count,
        error: state.error,
        getProformaReportHandler,
        clearProformaStateHandler,
        getClientsHandler,
      }}
    >
      {children}
    </ProformaReportContext.Provider>
  );
};
